<div class="panel panel-data">
    <div class="panel-header">
        <h3 class="panel-title">{{indexFamily}} Indices</h3>
        <div class="panel-actions">
            <div class="panel-action">
                <a class="btn btn-secondary" data-toggle="modal" (click)="editColumnsModal.openModal()">Edit Columns</a>
            </div>
        </div>
    </div>
    <div class="panel-pagination d-flex">
        <div class="panel-pagination-content ml-auto">
            <div class="panel-pagination-count">Viewing {{paginationInfo.start_index}}-{{paginationInfo.end_index}} of {{paginationInfo.num_items}} Indices</div>
            <ycn-pagination-controls class="panel-pagination-content"
                                     [disableButtons] = "loading"
                                     [paginationInfo]="paginationInfo"
                                     (pageChangeHandler)="pageChanged($event)">
            </ycn-pagination-controls>
        </div>
    </div>
    <div class="panel-content">
        <div class="divider-horizontal"></div>
        <div class="company-financials-table-wrap" style="margin-right: 0px;">
            <div *ngIf="loading" class="panel-content d-flex justify-content-center align-items-center">
                <ycn-loading-symbol [loaderMessage]="'Loading Indices...'"></ycn-loading-symbol>
            </div>
            <div *ngIf="!loading" class="company-financials-table" style="margin-left: 190px;">
                <table *ngIf="!noData else noDataTemplate" class="table">
                    <thead>
                    <tr>
                        <th *ngFor="let calc of columnsInfo"
                            [ngClass]="getHeaderClass(calc)"
                            (click)="setSortBy(calc.metricInternalName)"
                            class="user-select-none">
                            <div class="sort-mark"></div>
                            &nbsp;
                            <div class="d-inline text-underline-hover">{{calc.metricDisplayName}}</div>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let row of currentIndicesShown">
                        <td class="table-dynamic-name-middle">
                            <a [href]="row.rowData.url">{{ row[SYMBOL_COLUMN] }}</a>
                        </td>
                        <td class="text-nowrap">{{ row[NAME_COLUMN] }}</td>
                        <ng-container *ngFor="let calc of columnNames">
                            <td class="text-right">{{row.rowData[calc]}}</td>
                        </ng-container>
                        <td></td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
<ycn-index-family-edit-columns-modal #editColumnsModal></ycn-index-family-edit-columns-modal>
<ng-template #noDataTemplate>
    <table class="table text-right">
        <div class="panel-data-empty-message">No Data Available</div>
        <tbody>
        <tr *ngFor="let _ of [].constructor(10)">
            <td *ngFor="let _ of [].constructor(3)" class="td-index">
                <div class="td-ellipsis">&nbsp;</div>
            </td>
        </tr>
        </tbody>
    </table>
</ng-template>
